import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'

const ShinyokohamaRouteMap = ({ locale, themeName }) => {
  const getStationsByLineId = (lineId) => {
    return MasterData.trainPositionTab(lineId).stations.map(station => MasterData.station(station.id))
  }

  const stations = getStationsByLineId(3)

    return (
      <ul className="d-Routemap-station">
        <li className="d-Routemap-stationItem d-Routemap-stationItem--first">
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_other is_station"></div>
          </div>
          <FormattedMessage id='App.TrainPositions.thruToTokyu'>
            {(txt) => <div className="d-Routemap-lineText d-Routemap-lineText--toToyokoMeguroLine">{txt}</div>}
          </FormattedMessage>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_tokyuShinyokohama is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations.slice(-3)[0][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_tokyuShinyokohama is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem d-Routemap-stationItem--lg">
          <div className="d-Routemap-stationInfo">
            {locale === 'en' ? ( <p className="d-Routemap-stationName"><span>Hazawa</span> yokohama-kokudai</p>) : (<p className="d-Routemap-stationName">{stations.slice(-3)[1][`name_${locale}`]}</p>)}
          </div>

          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_local"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromShinyokohamaToLeft is_jr"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromShinyokohamaToMain is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromShinyokohamaToMain is_local"></div>
          </div>
          <FormattedMessage id='App.TrainPositions.thruToJR' values={{br: ''}} >
            {(txt) => <div className="d-Routemap-lineText d-Routemap-lineText--toSaikyoKawagoeLine">{txt}</div>}
          </FormattedMessage>
          
          <Link to={`/lines/main/route_map`} className={`d-Routemap-lineSwitch d-Routemap-lineSwitch-${themeName} d-Routemap-lineSwitch--fromShinyokohamaToMain`}>
            <p className="d-Routemap-lineSwitchText">{MasterData.line(1)[`name_${locale}`]}</p>
          </Link>
        </li>
      </ul>
    )
}

ShinyokohamaRouteMap.propTypes = {
  locale: PropTypes.string.isRequired,
  themeName: PropTypes.string.isRequired,
}

export default ShinyokohamaRouteMap
